import { render, staticRenderFns } from "./UpVideo.vue?vue&type=template&id=64eb9d4a&scoped=true&"
import script from "./UpVideo.vue?vue&type=script&lang=js&"
export * from "./UpVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eb9d4a",
  null
  
)

export default component.exports